export interface LikeOptions {
  clientId?: string;
  keyPrefix?: string;
}
